module.exports = __webpack_public_path__ + "img/slider4.14ed6c79.png";